module.exports = __webpack_public_path__ + "img/Room5_015.32636304.svg";